import { Injectable } from '@angular/core';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ExpiringSessionCountdownComponent } from './modal/expiring-session-countdown/expiring-session-countdown.component';
import { NotificationComponent } from './modal/notification/notification.component';
@Injectable({
  providedIn: 'root'
})
export class SharedService {
  dialogRef?: DynamicDialogRef | null;
  displayingExpiringSessionModal = false;

  constructor(private dialogService: DialogService) { }

  showNotification(isSuccess: boolean, title: string, message: string) {
    this.dialogRef = this.dialogService.open(NotificationComponent, {
      header: title,
      data: {
        isSuccess,
        title,
        message
      }
    });
  }

  openExpiringSessionCountdown = async () => {
    this.dialogRef = this.dialogService.open(ExpiringSessionCountdownComponent, {
      header: 'Session Timeout Warning',
      closable: false,
      modal: true
    });
  }
}
